<script lang="ts">
  import {
    getFormDividerStyle,
    styleToString,
  } from "@shared/common/node/style";
  import type { IFormDividerNode, PartialNode } from "@shared/common/node/type";
  import detectReaction from "../../actions/detect-reaction";
  import { getCurrentDocumentNode, getStore } from "../../context";

  const { reactionEventListener, formNode } = getStore();
  const documentNode = getCurrentDocumentNode();

  export let node: PartialNode<IFormDividerNode>;
</script>

<hr
  use:detectReaction={{
    node,
    documentNode,
    onAction: reactionEventListener,
  }}
  style={styleToString(getFormDividerStyle({ formNode: $formNode, node }))}
/>
